<template>
		<router-view></router-view> 
</template>

<script>
import LoginComponent from './views/user/auth/LoginView.vue';
import DashboardComponent from './views/user/dashboard/DashboardView.vue';

export default {
	components:{
		LoginComponent: LoginComponent,
		DashboardComponent: DashboardComponent,
	}
	
}
</script>

<style>
</style>
